import React, { MouseEventHandler } from 'react';

interface BulkActionOptionProps {
  adminOnly?: boolean;
  ariaDisabled?: boolean;
  children: React.ReactNode;
  href?: string;
  icon: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
}

const BulkActionOption = React.forwardRef<HTMLAnchorElement, BulkActionOptionProps>(({
  adminOnly, ariaDisabled, children, href, icon, onClick, ...rest
}, ref) => (
  <a
    ref={ref}
    aria-disabled={ariaDisabled}
    className={`dropdown-item ${ariaDisabled ? 'tw-opacity-50 tw-cursor-not-allowed' : ''}`.trim()}
    href={href}
    role="button"
    onClick={onClick}
    {...rest}
  >
    <i
      aria-hidden="true"
      className={`fa fa-${icon}`}
    />
    {children}
    {adminOnly && <i aria-hidden="true" className="fa fa-lock ml5" />}
  </a>
));

export default BulkActionOption;
